import Vue from 'vue';
// import sys from '@/services/system';

const dynamicview = {
    namespaced: true,
    state: {
        isPending: false,
        isVisible: false,

        resolve: null,
        reject: null,

        dataSource: [
            {
                group: { 
                    label: "Группа", 
                    name: "Группа"
                }, 
                values: [ 
                    {
                        field: {
                            componentName: "v-field-edit-number",
                            reference: null,
                            label: "Значение показателя 1",
                            value: null
                        }
                    },                     {
                    field: {
                            componentName: "v-field-edit-number",
                            reference: null,
                            label: "Значение показателя 2",
                            value: null
                        }
                    },                     {
                    field: {
                            componentName: "v-field-edit-number",
                            reference: null,
                            label: "Значение показателя 3",
                            value: null
                        }
                    },                    
                ]
            }
        ],
        key: ""
    },
    mutations: {
        SET_IS_PENDING(state, payload) {
            state.isPending = payload;
        },
        SET_IS_VISIBLE(state, payload) {
            state.isVisible = payload;
        },
        SET_RESOLVE(state, payload) {
            state.resolve = payload;
        },
        SET_REJECT(state, payload) {
            state.reject = payload;
        },  
        SET_DATASOURCE(state, payload) {
            state.dataSource = payload;            
        },
        SET_KEY(state, payload) {
          state.key = payload;  
        },
        UPDATE_DATASOURCE(state, payload) {     
            
            if (!this._vm.$_.has(state.dataSource, payload.property)) 
                Vue.set(state.dataSource, payload.property, payload.value)
            else
                this._vm.$_.set(state.dataSource, payload.property, payload.value)
        },
    },
    actions: {
        // async open({ commit }, serviceCode) {

        //     if (!Object.prototype.hasOwnProperty.call(sourceData.serviceCodes, serviceCode))
        //     {
        //         this._vm.$notify.alert(`Для услуги с кодом - ${serviceCode} не определены свойства.`);
        //         return;
        //     }

        //     let dataSource = this._vm.$_.orderBy(
        //         this._vm.$_(sourceData.serviceCodes[serviceCode].fields.map(f => ({name: f, field: JSON.parse(JSON.stringify(sourceData.fields[f])) }) ))
        //             .groupBy('field.group')
        //             .map((value, key) => ({ group: sourceData.groups.find(g => g.name == key), values: this._vm.$_.orderBy(value, ['field.order'], ['asc']) }))
        //             .value(), 
        //         ['group.order'], ['asc']
        //     );
            
        //     commit('SET_KEY', sys.generateUUID());
        //     commit('SET_DATASOURCE',dataSource);
        //     commit('SET_IS_VISIBLE', true);

        //     return new Promise((resolve, reject) => {
        //         commit('SET_RESOLVE', resolve);
        //         commit('SET_REJECT', reject);
        //     });
        // },
        async ok({ commit, state }) {
            commit('SET_IS_VISIBLE', false);
            
            let result = {};

            state.dataSource.forEach(e => {
                e.values.forEach(v => {
                    result[v.name] = v.field.value;
                })
            });

            state.resolve(result);
        },
        // async cancel({ commit, state }) {
        //     commit('SET_IS_VISIBLE', false);
        //     state.reject({ message: "Cancelled" });
        // },
        updateDataSource({ commit }, data) {
            commit('UPDATE_DATASOURCE', data);
        },
    },
    getters: {
        isPending: (s) => s.isPending,
        isVisible: (s) => s.isVisible,
        
        //isValid: (s) => s.dataSource?.some(e => !e.values?.some(v => !(typeof(v.field.value) === 'boolean' || !!v.field.value) )) ?? false,
        isValid: () => true,
        dataSource: (s) => s.dataSource,
        skey: (s) => s.key,
    }
}

export default dynamicview;